module.exports = __webpack_public_path__ + "img/mine_icon_header_boy.e535b52f.png";